import { GENERAL_MODULE_NAME } from '../const';

export const MODULE_NAME = GENERAL_MODULE_NAME.concat('_list');
export const LIST_PAGE_TYPE_ID = 0;
export const PUBLIC_DOCUMENT_LIST_URL = '/document/publicDocumentListJson';
export const PUBLIC_DOCUMENT_LIST_LOGOUT_URL = '/document/publicdocumentlogout';
export const PUBLIC_DOCUMENT_LIST_PATH = '/document/publicdocumentlist';
export const PUBLIC_DOCUMENT_DOWNLOAD_URL = '/document/publicdocumentdownload';
export const DOCUMENT_READER_UPDATE_PDF_DOCUMENT_FORM_URL = '/document/UpdatePublicPdfDocumentFormFieldsJson';
export const DOCUMENT_READER_UPDATE_PDF_DOCUMENT_FORM_URL_NEW = '/document/UpdatePublicPdfDocumentFormFieldsByIdsJson';
